import { activity_recent, and, desc, eq, type PowerSyncDrizzleDB } from "@time-tracker/powersync";

const DEFAULT_FEED_LIMIT = 200;

/**
 * Local activity feed (PowerSync bucket `activity_recent`, ~90 days).
 * The account's SQLite contains only its buckets (personal scope + shared
 * lists), so there is no need to filter by user again.
 * Canonical order: server_ts DESC (UUIDv7 id as tiebreaker).
 */
export function getActivityFeedQuery(db: PowerSyncDrizzleDB, options: { limit?: number } = {}) {
  return db
    .select()
    .from(activity_recent)
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}

/**
 * Local history of a specific entity (for the detail's "History" sheet).
 * Deep history (beyond retention) is requested from the API
 * (`GET /api/activity/entity/:type/:id`).
 */
export function getEntityActivityQuery(
  db: PowerSyncDrizzleDB,
  entityType: string,
  entityId: string,
  options: { limit?: number } = {},
) {
  return db
    .select()
    .from(activity_recent)
    .where(
      and(eq(activity_recent.entity_type, entityType), eq(activity_recent.entity_id, entityId)),
    )
    .orderBy(desc(activity_recent.server_ts), desc(activity_recent.id))
    .limit(options.limit ?? DEFAULT_FEED_LIMIT);
}
